export default __webpack_public_path__ + "static/media/Neutrif-Studio-SemiBold.f8b51314.ttf";